import React from 'react';
import { clsx } from 'clsx';

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  children: React.ReactNode;
}

export function TableRow({ children, className, ...props }: TableRowProps) {
  return (
    <tr 
      className={clsx("hover:bg-gray-50 transition-colors duration-200", className)} 
      {...props}
    >
      {children}
    </tr>
  );
} 